import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5baec815")

_pushScopeId("data-v-5baec815")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("添加幻灯片")
const _hoisted_2 = { class: "label" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_IconPlus = _resolveComponent("IconPlus")
  const _component_ThumbnailSlide = _resolveComponent("ThumbnailSlide")
  const _component_Draggable = _resolveComponent("Draggable")
  const _directive_contextmenu = _resolveDirective("contextmenu")
  const _directive_click_outside = _resolveDirective("click-outside")

  return _withDirectives((_openBlock(), _createBlock("div", {
    class: "thumbnails",
    onMousedown: _cache[2] || (_cache[2] = () => _ctx.setThumbnailsFocus(true)),
    onDrop: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.drop && _ctx.drop(...args))),
    onDragover: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.allowDrop && _ctx.allowDrop(...args)))
  }, [
    _createVNode("div", {
      class: "add-slide",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.createSlide()))
    }, [
      _createVNode(_component_IconPlus, { class: "icon" }),
      _hoisted_1
    ]),
    _createVNode(_component_Draggable, {
      class: "thumbnail-list",
      modelValue: _ctx.slides,
      animation: 300,
      scroll: true,
      scrollSensitivity: 50,
      onEnd: _ctx.handleDragEnd,
      itemKey: "id"
    }, {
      item: _withId(({ element, index }) => [
        _withDirectives(_createVNode("div", {
          class: ["thumbnail-item droptarget", {
            'active': _ctx.slideIndex === index,
            'selected': _ctx.selectedSlidesIndex.includes(index),
          }],
          onMousedown: $event => _ctx.handleClickSlideThumbnail($event, index)
        }, [
          _createVNode("div", _hoisted_2, _toDisplayString(_ctx.fillDigit(index + 1, 2)), 1),
          _createVNode(_component_ThumbnailSlide, {
            class: "thumbnail",
            slide: element,
            size: 120
          }, null, 8, ["slide"])
        ], 42, ["onMousedown"]), [
          [_directive_contextmenu, _ctx.contextmenusThumbnailItem]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "onEnd"])
  ], 544)), [
    [_directive_click_outside, () => _ctx.setThumbnailsFocus(false)],
    [_directive_contextmenu, _ctx.contextmenusThumbnails]
  ])
})